__webpack_require__.p = "https://app.ripple.com.au/packs/";